"use client";

import { useDevtoolsStore } from "@watt/crm/store/devtools";
import { Label } from "@watt/ui/components/ui/label";
import { Switch } from "@watt/ui/components/ui/switch";

/**
 * Restricts the app to Aperture-only behaviour while developing locally.
 */
export function ApertureOnlySetting() {
  const isApertureOnly = useDevtoolsStore.use.isApertureOnly();
  const setIsApertureOnly = useDevtoolsStore.use.setIsApertureOnly();

  return (
    <div className="flex items-center justify-between gap-3">
      <Label className="text-sm" htmlFor="aperture-only-toggle">
        Aperture Only
      </Label>
      <Switch
        checked={isApertureOnly}
        id="aperture-only-toggle"
        onCheckedChange={setIsApertureOnly}
        size="sm"
      />
    </div>
  );
}
